/**
 * The error for an edit aimed at an asset the scene design locks (serialized as READONLY_* or
 * omitted as non-recommendable). A bare "not editable" read as a transient failure, so the agent
 * retried the same call or tried a sibling tool on it; saying it is fixed artwork stops the loop.
 */
export const nonEditableAssetError = (assetName: string, sceneShortId: string): string =>
    `Error: Asset ${assetName} in scene ${sceneShortId} is not editable: it is fixed artwork that is part of the scene design, so its content can't be changed. Leave it as it is and edit the scene's editable assets instead (or choose a different scene design).`;
